export class Pagination {
    constructor(sortBy?: string) {
        this.sortBy = sortBy;
    }
    public sortBy = '';
    public page = 0;
    public asc = false;
    public searchTerm = '';
}
